import { FC, useEffect, useState } from 'react';
import './StockInventory.css';
import eFormType from '../../../../main/assets/enums/eFormType';
import { useForm } from 'react-hook-form';
import GeneralInput from '../../../../main/components/generalInput/GeneralInput';
import React from 'react';
import IProductStock from '../../../../main/interfaces/IProductStock';
import { ApiConstants } from '../../../../main/constants/ApiConstants';
import { toast } from 'react-toastify';
import axiosInstance from '../../../../main/initializers/axios';
import IProduct from '../../../../main/interfaces/IProduct';
import GeneralSelect from '../../../../main/components/select/GeneralSelect';
import { useTranslation } from 'react-i18next';

interface Props {
  tempProduct?: any;
  products?: IProduct[];
  modalType: eFormType;
  onSubmitData: () => void;
  createOrUpdate: boolean;
}

const StockInventory: FC<Props> = (props: Props) => {
  const { tempProduct, products, createOrUpdate, modalType, onSubmitData } = props;

  const { i18n } = useTranslation();

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<IProductStock>({
    defaultValues: {
      id: modalType === eFormType.Edit ? tempProduct?.id : '',
      quantity: modalType === eFormType.Edit ? tempProduct?.quantity : '',
      productId: modalType === eFormType.Edit ? tempProduct?.productId : '',
      buyingPrice: modalType === eFormType.Edit ? tempProduct?.buyingPrice : '',
      minQuantity: modalType === eFormType.Edit ? tempProduct?.minQuantity : '',
      sellingPrice: modalType === eFormType.Edit ? tempProduct?.sellingPrice : '',
    },
  });

  const onSubmit = (data: any) => {
    const params = {
      Id: Number(data.id),
      ProductId: Number(data.productId),
      Quantity: Number(data.quantity),
      BuyingPrice: Number(data.buyingPrice),
      MinQuantity: Number(data.minQuantity),
      SellingPrice: Number(data.sellingPrice),
    };
    axiosInstance.post(ApiConstants.stock.update, params).then((response) => {
      if (response.status === 200) {
        toast.success('U krijua me sukses');
      } else {
        toast.error('dicka shkoj Gabim');
      }
    });
  };

  useEffect(() => {
    if (createOrUpdate) {
      handleSubmit(onSubmit)();
      onSubmitData();
    }
  }, [createOrUpdate]);

  return (
    <div className="row">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="col-sm-12">
          <div className="form-row formRowCDR">
            <div className="form-group  col-md-6 formInputStyle">
              <GeneralInput
                required={true}
                label={i18n.t('stockDetails.buyingPrice')}
                name="buyingPrice"
                type="text"
                placeholder={i18n.t('stockDetails.buyingPrice')}
                errors={errors}
                control={control}
              />
            </div>
            <div className="form-group col-md-6 formInputStyle">
              <GeneralInput
                required={true}
                label={i18n.t('generic.quantity')}
                name="quantity"
                type="text"
                placeholder={i18n.t('generic.quantity')}
                errors={errors}
                control={control}
              />
            </div>
          </div>
          <div className="form-row formRowCDR">
            <div className="form-group  col-md-6 formInputStyle">
              <GeneralInput
                required={true}
                label={i18n.t('stockDetails.sellingPrice')}
                name="sellingPrice"
                type="text"
                placeholder={i18n.t('stockDetails.sellingPrice')}
                errors={errors}
                control={control}
              />
            </div>
            <div className="form-group col-md-6 formInputStyle">
              <GeneralInput
                required={true}
                label={i18n.t('stockDetails.minQuantity')}
                name="minQuantity"
                type="text"
                placeholder={i18n.t('stockDetails.minQuantity')}
                errors={errors}
                control={control}
              />
            </div>
          </div>
          <div className="form-row formRowCDR">
            <GeneralSelect
              preSelectedVal={i18n.t('stockDetails.selectProduct')}
              setSelectedVal={(val) => console.log(val)}
              data={products}
              required={true}
              errors={errors}
              control={control}
              label={i18n.t('generic.product')}
              name="productId"
              value="name"
            />
          </div>
          <hr />
        </div>
      </form>
    </div>
  );
};

export default StockInventory;
